import React from 'react';

/**
 * FooterSection - Footer with social links
 * Exact content from original index.html
 */
function FooterSection() {
  return (
    <section className="bg-light text-center">
      <h2 className="d-none">hidden</h2>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="footer-social">
              <ul className="list-unstyled">
                <li>
                  <a className="wow fadeInDown" href="https://www.linkedin.com/company/dataflexenergy">
                    <i className="fa fa-linkedin" aria-hidden="true"></i>
                  </a>
                </li>
                {/* Preserved commented Instagram link for future */}
                {/*<li>
                  <a className="wow fadeInUp" href="javascript:void(0);">
                    <i className="fa fa-instagram" aria-hidden="true"></i>
                  </a>
                </li>*/}
                <li>
                  <a className="wow fadeInDown" href="mailto:projects@dataflexep.com">
                    <i className="fa fa-envelope-o" aria-hidden="true"></i>
                  </a>
                </li>
              </ul>
            </div>
            <p className="company-about fadeIn">&copy; 2025 DataFlex Energy Partners.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FooterSection;